import React, { useState, useEffect } from 'react';

interface InactivityWarningModalProps {
  onStay: () => void;
  onLogout: () => void;
  countdownSeconds?: number;
}

const InactivityWarningModal: React.FC<InactivityWarningModalProps> = ({ onStay, onLogout, countdownSeconds = 60 }) => {
  const [countdown, setCountdown] = useState(countdownSeconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-8 rounded-lg shadow-xl text-center max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Are you still there?</h2>
        <p className="text-gray-600 mb-6">
          For your security, you will be logged out due to inactivity in{' '}
          <span className="font-bold text-red-600">{countdown}</span> seconds.
        </p>
        <div className="flex justify-center space-x-4">
          <button
            onClick={onLogout}
            className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg font-semibold hover:bg-gray-300"
          >
            Log Out
          </button>
          <button
            onClick={onStay}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700"
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
